export type HtmCodeGroupId = HtmCodeGroupParameterId;

export type HtmCodeGroupParameterId =
  | 'sonstige-sepsis'
  | 'pneumonie'
  | 'harnwegsinfektion'
  | 'infektion-nach-eingriff'
  | 'clostridioides-difficile'
  | 'mre';

export const HTM_CODE_GROUP_ID_DISPLAY_NAMES: {
  [id in HtmCodeGroupId]: string;
} = {
  'clostridioides-difficile': 'Clostridioides difficile',
  harnwegsinfektion: 'Infektion des Harnsystems',
  'infektion-nach-eingriff': 'Infektionen nach Eingriffen',
  mre: 'MRE',
  pneumonie: 'Infektion untere Atemwege',
  'sonstige-sepsis': 'Sepsis',
};
